import React, { useMemo, useState } from "react";
import intl from "react-intl-universal";
import styled from "styled-components";

import { Vector3D } from "../../../../../../script/lod2";
import antennaUtils from "../../../../../../script/utils/antennaUtils";

import { Overview3dHelper } from "./Overview3dHelper";

const ItemStyle = styled.div`
    border-radius: 2px;
    gap: 10px;
    display: flex;
    flex-direction: column;
    font-size: 12px;
`;

const AntennaLineStyle = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 11px;
`;

export const Overview3dAntennasList = props => {
    const { entry, triangles } = props;
    const [expanded, setExpanded] = useState(false);
    const antennasToSmallestDistanceToSurface = useMemo(() => {
        const antennas = antennaUtils.loadAntennas(entry);

        const antennasToSmallestDistanceToSurface = antennas.map(antenna => {
            const { positionX, positionY, height } = antenna;
            const antennaOrigin = new Vector3D(positionX, positionY, height);
            const projections = triangles
                .map(triangle => {
                    const projectedZ = Overview3dHelper.projectPointVerticallyOntoTriangle(antennaOrigin, triangle[0], triangle[1], triangle[2]);
                    if (projectedZ !== undefined) {
                        return antennaOrigin.z - projectedZ;
                    }
                    return undefined;
                })
                .filter(distance => distance !== undefined)
                .sort();
            const key = `${antenna.index + 1} ${antenna.antennaName} ${antenna.operator ? intl.get(`enum.operator.${antenna.operator}`) : ""} ${antenna.direction} ${antenna.height?.toFixed(2)}`;
            const smallestDistance = projections[0] !== undefined ? Math.round(projections[0] * 100) / 100 : undefined;
            return { antenna, smallestDistance, key };
        });
        return antennasToSmallestDistanceToSurface;
    }, [entry, triangles]);

    return (
        <ItemStyle>
            <div onClick={() => setExpanded(!expanded)}>
                {`${intl.get("entry.plan.overview3d.antennasListTitle")} ${expanded ? "▲" : "▼"}`}
            </div>
            {expanded &&
                antennasToSmallestDistanceToSurface.map(({ smallestDistance, key }) =>
                    <AntennaLineStyle key={key}>
                        <div>{`${key}: `}</div>
                        <div>{`${smallestDistance !== undefined ? `${smallestDistance}`.replace(".", ",") : "∞"}`}</div>
                    </AntennaLineStyle>
                )
            }
        </ItemStyle>
    );
};
